import { type BasicCallhomeSite } from '@solinkcorp/api-types';
import { useStaleSWRConfig } from '@solinkcorp/utils/hooks';
import React from 'react';
import useSWR from 'swr';
import { useCallhomeClient } from '../context';

export const BASIC_SITES_KEY = 'basic-sites';

export function useBasicSites() {
  const callhomeClient = useCallhomeClient();
  const staleSWRConfig = useStaleSWRConfig(BASIC_SITES_KEY);

  const sitesRes = useSWR(BASIC_SITES_KEY, () => callhomeClient.getBasicSites(), {
    ...staleSWRConfig,
    fallbackData: [],
  });

  const sites = React.useMemo(
    () => sitesRes.data?.slice().sort((a, b) => a.name.localeCompare(b.name)),
    [sitesRes.data],
  );

  return { ...sitesRes, sites };
}

export function useBasicSitesById() {
  const { sites } = useBasicSites();
  return React.useMemo(() => {
    const byId: Record<string, BasicCallhomeSite> = {};
    for (const site of sites ?? []) {
      byId[site.id] = site;
    }
    return byId;
  }, [sites]);
}
